/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Parts_Not_FoundInputs */

const en_ticket_action_parts_not_found = /** @type {(inputs: Ticket_Action_Parts_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts Not Found`)
};

const ja_ticket_action_parts_not_found = /** @type {(inputs: Ticket_Action_Parts_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品が見つからない`)
};

const fr_ticket_action_parts_not_found = /** @type {(inputs: Ticket_Action_Parts_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces introuvables`)
};

const de_ticket_action_parts_not_found = /** @type {(inputs: Ticket_Action_Parts_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Parts Not Found" |
*
* @param {Ticket_Action_Parts_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_parts_not_found = /** @type {((inputs?: Ticket_Action_Parts_Not_FoundInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Parts_Not_FoundInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_parts_not_found(inputs)
	if (locale === "ja") return ja_ticket_action_parts_not_found(inputs)
	if (locale === "fr") return fr_ticket_action_parts_not_found(inputs)
	return de_ticket_action_parts_not_found(inputs)
});